import {
  ImagePosition,
  INewsDetailsContentWithIllustrationModel,
} from 'models/news-details-model';
import React from 'react';
import ContentRenderer from '../editorjs/editorjs-renderer';

import styles from './news-content-with-illustration.module.scss';
import ImageRender from '../common/image-render';

type Props = {
  content: INewsDetailsContentWithIllustrationModel;
};

export default function NewsContentWithIllustration({ content }: Props) {
  if (!content) return <></>;

  return (
    <div
      className={`${styles.container} ${
        content.imagePosition == ImagePosition.Droite ? styles.reverse : ''
      }`}>
      {content.image && (
        <div className={styles['image']}>
          <ImageRender image={content.image} />
        </div>
      )}
      <div>
        <ContentRenderer content={content.content} />
      </div>
    </div>
  );
}
